import bannerExpertTrial6MonthsPNG from '../assets/images/consultant-checkout/banner-expert-trial-6-months.png';
import bannerExpertPNG from '../assets/images/consultant-checkout/banner-expert.png';

export const subscriptionConsultantPlans = [
  {
    id: 0,
    planId: 'plan_WypgoN2bIGhXoZ9Q',
    planImage: bannerExpertPNG,
    planName: 'Plano Expert Completo',
    originalPrice: 39900,
    price: 14990,
  },
  {
    id: 1,
    planId: 'plan_yxY10DixqF4G1N0Z',
    planImage: bannerExpertTrial6MonthsPNG,
    planName: 'Plano Expert Mensal Academy',
    originalPrice: 39900,
    price: 14990,
  },
];
